"use client";

import { EDocSubscriptionEmailDto, GetEdocsDto } from "@onair/repositories";
import Carousel from "./carousel";
import DialogRegisterDocument, {
	DialogRegisterDocumentProps,
} from "#src/components/dialog-register-document";
import { lazy, useState } from "react";
import { useCreateEdocSubsciptionEmail } from "@onair/operations";
import DialogSubscribeDocumentSuccess from "#src/components/dialog-register-document/dialog-subscribe-document-success";
import CardEdoc from "#src/components/edocs/card-edoc";
import dynamic from "next/dynamic";

interface EdocumentListProps {
	className?: string;
	items: GetEdocsDto[];
}
const EdocumentList: React.FC<EdocumentListProps> = ({ className, items }) => {
	const [isShowDialogSuccess, setShowDialogSuccess] = useState(false);
	const [selectedDocument, setSelectedDocument] = useState<GetEdocsDto>();
	const { mutate: subscribeEdoc, isPending } = useCreateEdocSubsciptionEmail();

	const handleSubmit: DialogRegisterDocumentProps["onSubmit"] = (formData) => {
		if (!selectedDocument) return;

		const payload: EDocSubscriptionEmailDto = {
			edocId: selectedDocument?.id,
			email: formData.email,
			company: formData.company,
			isSubscribeEmailMKT: formData.isSubscribeEmailMKT,
			fullName: formData.fullName,
			phone: formData.phoneNumber,
			job: formData.job,
			learningDifficulty: formData.learningDifficulty,
		};
		subscribeEdoc(payload, {
			onSuccess(data, variables, context) {
				console.log(data);
				setShowDialogSuccess(true);
				setSelectedDocument(undefined);
			},
		});
	};
	return (
		<>
			<Carousel>
				{items.map((item) => (
					<CardEdoc
						key={item.id}
						data={{
							title: item.title,
							bannerUrl: item.bannerUrl,
							downloadCount: item.downloadCount,
							fileSize: item.size,
							hashtags: item.hashtags,
							publishedAt: item.publishedAt,
							description: item.description,
						}}
						onClick={() => setSelectedDocument(item)}
						className="rounded-xl overflow-hidden cursor-pointer aspect-[368/490]"
					/>
				))}
			</Carousel>
			<DialogRegisterDocument
				open={!!selectedDocument}
				documentDescription={selectedDocument?.description}
				documentName={selectedDocument?.title}
				onSubmit={handleSubmit}
				onClose={() => setSelectedDocument(undefined)}
			/>
			<DialogSubscribeDocumentSuccess
				open={isShowDialogSuccess}
				onClose={() => setShowDialogSuccess(false)}
			/>
		</>
	);
};
export default EdocumentList;
